class StoresList {
  constructor() {
    this.filterSelect = document.getElementById('region-filter');
    this.storeCards = document.querySelectorAll('.store-card');
    
    this.init();
  }

  init() {
    if (this.filterSelect) {
      this.filterSelect.addEventListener('change', this.handleFilterChange.bind(this));
    }

    // Add click handlers for store cards to show on map if map exists
    this.storeCards.forEach(card => {
      card.addEventListener('click', this.handleStoreCardClick.bind(this));
    });
  }

  handleFilterChange(event) {
    const selectedRegion = event.target.value.toLowerCase();
    
    this.storeCards.forEach(card => {
      const cardRegion = card.dataset.region.toLowerCase();
      
      if (selectedRegion === '' || cardRegion === selectedRegion) {
        card.style.display = '';
        card.setAttribute('aria-hidden', 'false');
      } else {
        card.style.display = 'none';
        card.setAttribute('aria-hidden', 'true');
      }
    });

    // Update visible count
    this.updateVisibleCount();
  }

  handleStoreCardClick(event) {
    // If clicked element is a link, let it handle navigation
    if (event.target.tagName === 'A' || event.target.closest('a')) {
      return;
    }

    // Find the main link in the card and navigate to it
    const link = event.currentTarget.querySelector('.store-card__link');
    if (link) {
      window.location.href = link.href;
    }
  }

  updateVisibleCount() {
    const visibleCards = Array.from(this.storeCards).filter(card => 
      card.style.display !== 'none'
    );
    
    // Dispatch custom event for other components that might want to know
    document.dispatchEvent(new CustomEvent('storesFiltered', {
      detail: {
        visibleCount: visibleCards.length,
        totalCount: this.storeCards.length
      }
    }));
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new StoresList();
});